module.exports = __webpack_public_path__ + "static/media/signage-indoor-img55.92ad4239.jpg";